import { BrowserRouter, Routes, Route } from "react-router-dom";

//import logo from "./logo.svg";
import "./App.css";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Main from "./components/main/Main";
import ShopStore from "./components/shopStore/ShopStore";
import Error from "./components/Error";
import Company from "./components/company/Company";


const App = () => {
	// const location = useLocation();

	// useEffect( () => {
	// 	if(location.hostname === "store.localhost:3000"){
	// 		window.location.href = "/store";
	// 	}
	// }, [location]);

	return (
		<BrowserRouter>
			<div className="container-1">
				<div>
					<Header />
				</div>
				<Routes>
					<Route
						path="/"
						element={
							<div>
								<Main />{" "}
							</div>
						}
					/>
					<Route
						path="/store"
						element={
							<div>
								<ShopStore />
							</div>
						}
					/>
					<Route
						path="/company"
						element={
							<div>
								<Company />{" "}
							</div>
						}
					/>
					<Route
						path="*"
						element={
							<div>
								<Error />
							</div>
						}
					/>
				</Routes>
				<div className="footer-comp">
					<Footer />
				</div>
			</div>
		</BrowserRouter>
	);
};

export default App;
